import type { ReactNode } from 'react'
import { openExternalLink } from '../../app/telegram'
import { openNativeMaps } from '../../app/nativeBridge'
import type { Store } from './api'
import { routeUrl } from './model'

export interface RouteLinkProps {
  store: Pick<Store, 'address' | 'lat' | 'lng'>
  className: string
  label: string
  children: ReactNode
}

/**
 * Маршрут до аптеки. В нашем приложении — карты телефона (обработчик
 * `openMaps`), в Telegram — его браузер, на сайте — сама ссылка на Яндекс Карты.
 */
export function RouteLink({ store, className, label, children }: RouteLinkProps) {
  return (
    <a
      className={className}
      href={routeUrl(store)}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      // Ссылка часто лежит в нажимаемой карточке аптеки: маршрут — своё
      // действие, ни нажатие, ни его отклик до карточки не доходят.
      onPointerDown={(event) => {
        event.stopPropagation()
      }}
      onClick={(event) => {
        event.stopPropagation()
        const native =
          store.lat !== null && store.lng !== null && openNativeMaps(store.lat, store.lng)
        if (native || openExternalLink(routeUrl(store))) event.preventDefault()
      }}
    >
      {children}
    </a>
  )
}
